import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dea5359e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dea5359e&prod&lang=stylus&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea5359e",
  null
  
)

export default component.exports